import cardProfile from './cardProfile.json';
import colorPicker from './colorPicker.json';
import readerFormat from './readerFormat.json';
import actionModal from './actionModal.json';
import conditionModal from './conditionModal.json';
import inviteModal from './inviteModal.json';
import confirmAction from './confirmAction.json';
import approveModal from './approveModal.json';
import onvifDiscovery from './onvifDiscovery.json';
import nvrChannels from './nvrChannels.json';
import cameraReaders from './cameraReaders.json';
import licenseModal from './licenseModal.json';
import facilityLicenseModal from './facilityLicenseModal.json';
import gatewayModal from './gatewayModal.json';
import whiteCardModal from './whiteCardModal.json';
import aperioLockModal from './aperioLockModal.json';
import firmwareUpdate from './firmwareUpdate.json';

export default {
  cardProfile,
  colorPicker,
  readerFormat,
  actionModal,
  conditionModal,
  inviteModal,
  confirmAction,
  approveModal,
  onvifDiscovery,
  nvrChannels,
  cameraReaders,
  licenseModal,
  facilityLicenseModal,
  gatewayModal,
  whiteCardModal,
  aperioLockModal,
  firmwareUpdate,
};
